module.exports = __webpack_public_path__ + "img/emoji_41.a7063f4b.png";